import React from 'react'
import './index.less';
import { Form, Input, Button, Icon, Modal,message } from 'antd';
import Axios from './../../axios';
import logo from '../../logo.png';
import Fingerprint from 'fingerprintjs';
const FormItem = Form.Item;
class Login extends React.Component {
    state = {
        loading: false,
    }
    componentWillMount() {
    }
    componentDidMount() {

    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                //console.log('form values: ', values);
                let params = {
                    ...values
                }
                this.setState({ loading: true });
                // return false;
                Axios.loginPost({
                    block: '/admin',
                    url: '/account/login',
                    params: params
                }).then(res => {
                    if(res.code == 0){
                        message.success('登录成功');
                        localStorage.setItem("token", res.object);
                        localStorage.setItem("account", res.data.username);
                        window.open(`/#/home`, '_self');
                    }else {
                        message.error(res.msg?res.msg:'登录失败');
                    }
                    this.setState({ loading: false });
                }).catch((error) => {
                    this.setState({ loading: false });
                })
            }
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className='login'>
                <div className="login-box">
                    <div className="title">
                        {/* <img src={logo} alt='logo'/> */}
                        英超名人堂管理系统
                    </div>
                    <Form>
                        <FormItem>
                            {getFieldDecorator('username', {
                                rules: [{ required: true, message: '请输入账号!' }],
                            })(
                                <Input prefix={<Icon type="user" />} type="text" size="large" placeholder="请输入账号" />
                            )
                            }
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('password', {
                                rules: [
                                    { required: true, message: '请输入密码!' },
                                    {
                                        min: 1,
                                        message: '密码长度不够！'
                                    },
                                ],
                            })(
                                <Input prefix={<Icon type="lock" />} type="password" size="large" placeholder="请输入密码" />
                            )
                            }
                        </FormItem>
                        <FormItem>
                            <Button type="primary" block={true} size="large" onClick={this.handleSubmit} loading={this.state.loading}>登录</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        );
    }
}
export default Form.create()(Login);




// WEBPACK FOOTER //
// ./src/pages/login/index.js